"use client";

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const komputerBogor: ReactNode = (
  <>
    <section>
      <h2 className="text-xl font-bold mb-2">Sewa Komputer Bogor: Solusi Efisien, Fleksibel, Siap Kirim</h2>

      <h3 className="text-lg font-semibold mb-2">Mengapa Sewa Komputer Bogor Jadi Pilihan Rasional?</h3>
      <p className="mb-4">
        Ketika anggaran terbatas tapi kebutuhan teknis mendesak, <strong>sewa komputer Bogor</strong> bukan lagi alternatif, tapi strategi. Kamu tak perlu beli puluhan unit mahal untuk kegiatan sesekali. Dari pelatihan kampus, simulasi ujian, hingga event korporat, semua bisa dijalankan tanpa harus punya perangkat sendiri.
      </p>
    </section>

    <section>
      <h3 className="text-lg font-semibold mb-2">Wilayah Layanan Sewa Komputer Bogor yang Luas</h3>
      <p className="mb-4">
        Kami menjangkau hampir semua kecamatan: Cibinong, Dramaga, Ciomas, Bojonggede, Gunung Putri, bahkan kawasan Cisarua dan Sentul. <strong>Sewa komputer Bogor</strong> yang cepat, aman, dan sampai tujuan tanpa drama.
      </p>
    </section>

    <section>
      <h3 className="text-lg font-semibold mb-2">Brand Komputer Ternama, Spek Tertinggi</h3>
      <p className="mb-4">
        Kami sediakan unit dari <strong>brand premium</strong> seperti Dell, HP, Lenovo, hingga rakitan spek tinggi (Core i7, RAM 16GB, SSD 512GB) untuk kebutuhan <strong>sewa komputer Bogor</strong> jangka pendek maupun panjang. Baik untuk desain, editing, simulasi CAD, hingga kebutuhan Ujian Nasional Berbasis Komputer (UNBK).
      </p>
    </section>

    <section>
      <h3 className="text-lg font-semibold mb-2">Harga Sewa Komputer Bogor Transparan & Fleksibel</h3>
      <p className="mb-4">
        Harga <strong>sewa komputer Bogor</strong> mulai dari 50rb-an per hari, tergantung tipe & spek. Sewa harian, mingguan, hingga bulanan tersedia. Mau 3 jam untuk simulasi atau 3 bulan untuk proyek kantor? Kami layani semua. Semakin lama sewa, semakin murah biayanya.
      </p>
    </section>

    <section className="space-y-4 mb-6">
      <article className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Support Langsung, Bisa Remote Maupun On-Site</h4>
        <p className="text-sm">
          Tim teknis kami standby setiap hari. Troubleshooting jarak jauh atau datang ke lokasi? Bisa dua²nya. Kami paham bahwa saat <strong>sewa komputer di Bogor</strong>, downtime 1 jam bisa mengacaukan semua jadwal.
        </p>
      </article>

      <article className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Unit Bersih, Aman dari Cuaca Bogor yang Hujan²</h4>
        <p className="text-sm">
          Bogor dikenal karena curah hujannya. Itulah kenapa semua unit <strong>sewa komputer Bogor</strong> kami dikemas tahan lembap dan anti-kaget. Packing kami bukan kardus biasa, tapi sistem proteksi berlapis dengan standar event profesional.
        </p>
      </article>

      <article className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Gratis Ongkir Area Kota Bogor & Negosiasi Sampai Deal</h4>
        <p className="text-sm">
          Area pusat kota Bogor kami layani dengan <strong>gratis ongkir</strong>. Untuk wilayah seperti Parung, Ciawi, dan Cibungbulang dikenakan ongkos logistik yang fair dan transparan. Hubungi tim kami, sebutkan lokasi dan durasi, dan kami pastikan kamu dapat penawaran <strong>sewa komputer Bogor</strong> terbaik.
        </p>
      </article>
    </section>

    <section>
      <h3 className="text-xl font-bold mb-3">Sewa Komputer di Bogor Tanpa Minimum Order</h3>
      <p className="mb-4">
        Tak semua vendor mengizinkan sewa hanya 1 unit. Kami berbeda. 1 unit pun tetap kami antar. Kamu mahasiswa skripsi, dosen pelatihan, atau panitia event? Semuanya dilayani setara.
      </p>
    </section>

    <section>
      <h3 className="text-xl font-bold mb-3">Jadwal Fleksibel, Waktu Kamu yang Kendalikan</h3>
      <p className="mb-4">
        Ingin <strong>sewa komputer Bogor</strong> mulai malam ini? Atau dijadwalkan untuk minggu depan? Tinggal chat tim kami dan kami atur waktunya. Kami bekerja saat kamu butuh, bukan sebaliknya.
      </p>
    </section>

    <section>
      <h3 className="text-xl font-bold mb-3">Garansi Ganti Unit Jika Rusak Selama Sewa</h3>
      <p className="mb-4">
        Jika unit bermasalah dalam masa <strong>sewa komputer Bogor</strong>, kami langsung kirim pengganti tanpa biaya. Prioritas kami adalah operasional kamu tetap berjalan, bukan sekadar menyewa.
      </p>
    </section>

    <CTA
      title="Siap Kerja Di Bogor Sampai Cisarua?"
      description="🚚 Butuh sewa komputer Bogor sekarang juga? Hubungi tim kami sekarang. <br />Selama unit ready, kami antar hari itu juga ke lokasi kamu."
      buttonText="Booking Komputer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer%20untuk%20Bogor%20dan%20sekitarnya.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Komputer" />
  </>
);

export default komputerBogor;